<template>
  <section class="app-integration">
    <header class="app-integration__header">
      <h1 class="app-integration__title">
        Marketplace e Consultório Virtual
      </h1>
    </header>

    <article class="app-integration__body">
      <router-view
        v-if="!isLoading"
        :doctor.sync="doctor"
        :chosen-offices.sync="chosenOffices"
        :is-telemedicine.sync="isTelemedicine"
      />
    </article>

    <div v-if="hasIntegratedApp" class="app-integration__revoke">
      <button
        class="btn app-integration__revoke-btn"
        @click="revokeIntegration()"
      >
        Revogar integração com Consultório Virtual
      </button>
    </div>

    <action-modal
      v-if="
        actionModal.show &&
        $route.name === 'DoctorAppIntegrationPresentation'
      "
      :active.sync="actionModal.show"
      :css="actionModal.css"
      :body="actionModal.body"
      :size="actionModal.size"
      :btn="actionModal.btn"
      :action="actionModal.action"
      @close="actionModal.show = false"
    />
  </section>
</template>

<script>
import actionModal from '@/components/modals/action'
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'DrAppIntegration',

  components: {
    actionModal
  },

  props: {
    doctor: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data () {
    return {
      chosenOffices: null,
      isTelemedicine: true,
      isLoading: false,
      steps: {},
      actionModal: {
        show: false,
        size: 'md4',
        css: `
          color: white !important;
          background: url(/static/img/integracao-health-place.png);
          background-size: cover;
          background-position: right center;
          width: 745px;
          max-width: 745px;
          `,
        btn: {
          class: 'btn-purple btn-md',
          text: 'Integrar agora'
        },
        body: `
          <div style="width: 500px;">
            <h2 style="color: white; margin: -1.1rem 0 1rem 0; font-weight: 700">
              Você conectado a mais pacientes
            </h2>

            <p style="font-weight: 600; margin: 0 2rem 0 0; hyphens: auto; width: 60%;">
              Marketplace é uma área especial e exclusiva para a classe médica dentro
              da plataforma Dr. Conecta.
              <br><br>
              É a forma que encontramos para convidar a classe médica a revolucionar o
              acesso à saúde de qualidade no Brasil.
              <br><br>
              Configure seus horários e o <strong style="color: #FFEDA8">Dr. Conecta
              buscará novos pacientes</strong> pra você.
              <br><br>
              <strong style="color: #FFEDA8">Marketplace:</strong> <strong>onde o
              nosso propósito se conecta com a sua agenda.</strong>
            </p>
          </div>
        `,
        action: function () {
          this.close()
        }
      },
      guardedRoutes: [
        'DoctorAppIntegrationEducation',
        'DoctorAppIntegrationOffices',
        'DoctorAppIntegrationPrices',
        'DoctorAppIntegrationFinance',
        'DoctorAppIntegrationHealthPlace',
        'DoctorAppIntegrationReview'
      ]
    }
  },

  computed: {
    ...mapGetters({
      appIntegration: 'getAppIntegration',
      healthPlaceIntegration: 'getHealthPlaceIntegration'
    }),

    hasIntegratedApp () {
      return this.appIntegration && this.appIntegration['is_active']
    },

    hasIntegratedHealthPlace () {
      if (
        this.healthPlaceIntegration &&
        'is_active' in this.healthPlaceIntegration
      ) {
        return this.healthPlaceIntegratin['is_active']
      }

      return false
    }
  },

  watch: {
    '$route.name': {
      deep: false,
      immediate: true,
      handler (route) {
        if (this.guardedRoutes.includes(route)) {
          this.isLoading = true
          this.fn_SHOW_PROGRESS()

          this.validateCertificate()
            .then((res) => {
              const { credentialExpiresAt } = res.data.data[0]

              // Mostra pop-up de alerta de certificado caso o certificado tenha expirado
              // e caso a integração não tenha sido completada
              if (
                this.$moment().isSameOrAfter(this.$moment(credentialExpiresAt)) &&
                !this.hasIntegratedApp
              ) {
                this.showAlert()
                this.$router.push({ name: 'DoctorAppIntegration' })
              }
            })
            .catch(() => {
              // Mostra pop-up de alerta de certificado caso não exista certificado
              // e caso a integração não tenha sido completada
              if (!this.hasIntegratedApp) {
                this.showAlert()
                this.$router.push({ name: 'DoctorAppIntegration' })
              }
            })
            .finally(() => {
              this.isLoading = false
              this.fn_HIDE_PROGRESS()
            })
        }
      }
    },

    hasIntegratedApp: {
      deep: true,
      immediate: true,
      handler (v) {
        if (!v) {
          this.actionModal.show = true
        }
      }
    }
  },

  created () {
    this.$moment.locale('pt-br')

    EventBus.$on('app-integration-pick-offices', payload => this.setChosenOffices(payload))

    this.getHealthPlaceIntegration()
      .then(res => this.$store.dispatch('setHealthPlaceIntegration', res))
  },

  mounted () {
    this.fn_HIDE_PROGRESS()
  },

  methods: {
    setChosenOffices (payload) {
      const { isChecked, offices } = payload

      if (offices) {
        this.chosenOffices = [...offices]
        this.isTelemedicine = isChecked
        this.$router.push({ name: 'DoctorAppIntegrationPrices' })
      }
    },

    validateCertificate () {
      const url = '/doctor/soluti_cess/credential?order[u.createdAt]=DESC&itensPerPage=1'

      return this.$http
        .get(url, this.$store.getters.getAuthHeader)
    },

    showAlert () {
      this.$store.dispatch('setModalConfirm', {
        title: 'Aviso',
        body: `Para sua segurança e a segurança dos pacientes,
          você precisa ter um certificado digital válido.
          Isso garante a autenticidade de seu perfil e dos
          documentos que serão gerados digitalmente por você.`,
        confirmText: 'Certificado Digital',
        cancelText: 'Ir para Agenda',
        beforeClose: (v) => {
          if (v) {
            this.$router.push({ name: 'DoctorUserCertificates' })
          } else {
            this.$router.push({ name: 'DoctorAgenda' })
          }

          this.$store.dispatch('setModalConfirm')
        },
        size: 'md1',
        active: true
      })
    },

    revokeIntegration () {
      this.$store.dispatch('setModalConfirm', {
        title: 'Atenção',
        body: `Tem certeza que deseja desativar sua página de perfil público
          para suas consultas particulares? Essa desativação não te remove do Marketplace.
          Para desativar tmabém o Marketplace, acesse a opção Marketplace e efetue a desativação.`,
        confirmText: 'Desativar perfil público',
        cancelText: 'Voltar',
        beforeClose: (v) => {
          this.$store.dispatch('setModalConfirm')

          if (v) {
            const url = `/doctor/app_integration/${this.appIntegration.id}/is_active`
            const data = {
              'update_is_active': {
                isActive: 0
              }
            }

            this.fn_SHOW_PROGRESS()
            this.$http
              .put(url, data, this.$store.getters.getAuthHeader)
              .then(this.getAppIntegration())
              .then(this.revokeHealthPlaceIntegration)
              .then(this.getHealthPlaceIntegration)
              .then(res => this.$store.dispatch('setHealthPlaceIntegration', res))
              .then(() => {
                this.$store.dispatch('setModalAlert', {
                  title: 'Sucesso',
                  body: 'A integração com o app Dr. Conecta foi desativada com sucesso',
                  size: 'md',
                  active: true,
                  callback: () => this.$router.push({ name: 'DoctorAgenda' })
                })
              })
              .catch(err => this.fn_HANDLE_ERROR(err))
              .finally(this.fn_HIDE_PROGRESS())
          }
        },
        size: 'md1',
        active: true
      })
    },

    getAppIntegration () {
      this.$http
        .get('/doctor/app_integration', this.$store.getters.getAuthHeader)
        .then(res => this.$store.dispatch('setAppIntegration', res.data['app_integration']))
    },

    getHealthPlaceIntegration () {
      return new Promise((resolve, reject) => {
        this.$http
          .get('/doctor/doctor_health_place', this.$store.getters.getAuthHeader)
          .then(res => resolve(res.data))
          .catch(() => resolve())
      })
    },

    revokeHealthPlaceIntegration () {
      if (this.hasIntegratedHealthPlace) {
        const url = `/doctor/doctor_health_place`
        const data = {
          'update': {
            medicalConsultationPrice: this.healthPlaceIntegration['medical_consultation_price'],
            isActive: 0
          }
        }

        return this.$http
          .put(url, data, this.$store.getters.getAuthHeader)
      }

      return true
    }
  }
}
</script>

<style lang="scss">
.btn-purple {
  background-color: #583D72;
  color: #ffffff;
  margin-bottom: 0.5rem;

  &:hover {
    background-color: darken(#583D72, 10%);
  }
}
</style>
